import React, { useState } from 'react';
import styled from '@emotion/styled';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import {
  Formik,
  Form,
} from 'formik';
import * as R from 'ramda';
import { useTheme } from '@material-ui/core';

import { colour } from '../constants/style';
import { HeaderText } from './text';
import { CommodityField } from './CommodityField';
import { CREDITS_PER_UNIT } from '../constants/commodityPrices';
import pkg from '../../package.json';


const topFields = [
  {
    name: 'transactionPercent',
    label: 'Transaction Fee',
    unitLabel: '%',
  },
];

const leftFields = [
  {
    name: 'metalCommon',
    label: 'Metal - Common',
  },
  {
    name: 'metalRare',
    label: 'Metal - Rare',
  },
  {
    name: 'oreCommon',
    label: 'Ore - Common',
  },
  {
    name: 'oreRare',
    label: 'Ore - Rare',
  },
  {
    name: 'rock',
    label: 'Rock',
  },
  {
    name: 'gasCommon',
    label: 'Gas - Common',
  },
  {
    name: 'gasRare',
    label: 'Gas - Rare',
  },
  {
    name: 'ice',
    label: 'Ice',
  },
  {
    name: 'isotope',
    label: 'Radioisotope',
  },
  {
    name: 'crystalCommon',
    label: 'Crystal - Common',
  },
  {
    name: 'crystalRare',
    label: 'Crystal - Rare',
  },
  {
    name: 'organic',
    label: 'Organic Compound',
  },
];

const rightFields = [
  {
    name: 'credit',
    label: 'Credits',
    unitLabel: 'cred',
  },
  {
    name: 'norveliosScrip',
    label: 'Norvelios Scrip',
    unitLabel: 'N-Scrip',
  },
  {
    name: 'tradeHouseKgDay',
    label: 'Trade House Storage',
    unitLabel: 'kg days',
  },
  {
    name: 'tradeHouseKgMonth',
    label: 'Trade House Storage',
    unitLabel: 'kg months',
  },
  {
    name: 'tradeHouseDeposit',
    label: 'Trade House Deposit',
    readOnly: true,
  },
];

const ConvertForm = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
  margin: 5px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
  
  ${({ theme }) => `@media (min-width: ${theme.breakpoints.values.md}px) {
      flex-direction: row;
    }`}
`;

const PageWrapper = styled.div`
  padding: 5px 10px;
  max-width: 100%;
  height: 100%;
  margin: auto;
  background-color: ${colour.background};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const InnerWrapper = styled.div`
  width: 100%;
`;

const Text = styled.p`
  color: ${colour.primary};
`;

const FieldGroup = (
  groupFields,
  lastChanged,
  setLastChanged,
) => (
  <Col>
    {R.map(
      ({
        name,
        label,
        Component = CommodityField,
        as = TextField,
        type = 'number',
        variant = 'standard',
        unitLabel = 'kg',
        ...rest
      }) => (
        <Component
          name={name}
          label={label}
          as={as}
          type={type}
          variant={variant}
          InputProps={{
            endAdornment: <InputAdornment position="end">{unitLabel}</InputAdornment>,
            ...rest,
          }}
          key={name}
          lastChanged={lastChanged}
          setLastChanged={setLastChanged}
          {...rest}
        />
      ),
      groupFields,
    )}
  </Col>
);


// TODO: maybe Yup https://github.com/jquense/yup
export const CommodityConverter = () => {
  const initialValues = R.pipe(
    R.map(() => ''),
    R.reject(R.isNil),
  )(CREDITS_PER_UNIT);
  initialValues.transactionPercent = 5;
  const [lastChanged, setLastChanged] = useState('');

  const theme = useTheme();
  return (
    <PageWrapper>
      <HeaderText>Commodity Converter</HeaderText>
      <InnerWrapper>
        <Formik
          initialValues={initialValues}
        >
          <ConvertForm>
            {FieldGroup(topFields, lastChanged, setLastChanged)}
            <Row theme={theme}>
              {FieldGroup(leftFields, lastChanged, setLastChanged)}
              {FieldGroup(rightFields, lastChanged, setLastChanged)}
            </Row>
          </ConvertForm>
        </Formik>
      </InnerWrapper>
      <Text>{`v ${pkg.version}`}</Text>
    </PageWrapper>
  );
};
